'use client';

import { Box, Typography, Grid } from "@mui/material";
import { useTranslations } from "next-intl";

export default function AixpressFeature() {
    const t = useTranslations("ServicePage.aixpress_feature");

    const features = [
        {
            title: "feature_1_title",
            description: "feature_1_desc"
        },
        {
            title: "feature_2_title",
            description: "feature_2_desc"
        },
        {
            title: "feature_3_title",
            description: "feature_3_desc"
        }
        // {
        //     title: "feature_4_title",
        //     description: "feature_4_desc"
        // }
    ]

    return (
        <Box sx={{ py: { xs: 8 }, backgroundColor: "#f8fafc" }}>
            <Box sx={{ maxWidth: "lg", margin: "auto", textAlign: "center", mb: 8, px: { xs: 2, md: 0 } }}>
                <span className="inline-block bg-[#F15859] text-white text-xs font-bold px-6 py-1.5 rounded-full mb-6 shadow-sm">
                    {t('chip')}
                </span>
                <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: "#132c4b", mb: 2 }}>
                    {t('title')}
                </Typography>
                <Typography variant="body1" sx={{ color: "#64748b" }}>
                    {t('description')}
                </Typography>
            </Box>

            <Box sx={{ maxWidth: "lg", margin: "auto", px: { xs: 2, md: 0 } }}>
                <Grid container spacing={4}>
                    {features.map((feature, index) => (
                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                                <div className="flex flex-col justify-start items-center gap-6 h-full">
                                    {/* <div className="flex-shrink-0 w-16 h-16 bg-[#F15859]/10 rounded-full flex items-center justify-center">
                                        {feature.icon}
                                    </div> */}
                                    <div className="text-center">
                                        <h3 className="text-xl font-bold text-[#132c4b] mb-3">
                                            {t(feature.title)}
                                        </h3>
                                        <Box sx={{ textAlign: "left" }}>
                                            <p className="text-slate-500 text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: t.raw(feature.description) }} />

                                        </Box>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    )
}